import styled from 'styled-components';

export const ModalDescription = styled.span`
font-family: "Open Sans", sans-serif;
font-size: 13px;
line-height: 18px;
text-align: left;
color: #6C7B94;
margin: 10px 0;
max-width: 50ch;
`

export const ModalHeading = styled.span`
font-family: "Open Sans", sans-serif;
font-size: 16px;
line-height: 22px;
color: #2A323E;
`